import { Clock3, Flame, Mail, MapPin, Phone, Smartphone, Wallet } from 'lucide-react';

const MENU_LINKS = [
  { href: '#menu', label: 'Full menu' },
  { href: '#how-it-works', label: 'How it works' },
  { href: '#about', label: 'About MLO' },
];

export function SiteFooter() {
  return (
    <footer className="border-t border-border bg-secondary text-secondary-foreground">
      <div className="brand-stripes h-2.5 w-full" aria-hidden />
      <div className="container grid gap-10 py-14 sm:grid-cols-2 lg:grid-cols-4">
        {/* Brand */}
        <div className="sm:col-span-2 lg:col-span-1">
          <div className="flex items-center gap-2.5">
            <span className="flex size-10 items-center justify-center rounded-xl bg-marigold text-accent-foreground">
              <Flame className="size-5" />
            </span>
            <span className="leading-none">
              <span className="block font-display text-2xl font-black tracking-tight">MLO</span>
              <span className="block text-[11px] font-semibold uppercase tracking-[0.18em] text-secondary-foreground/70">
                Kenyan Kitchen
              </span>
            </span>
          </div>
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-secondary-foreground/75">
            Kenya's favourite meals — breakfast, lunch and dinner — cooked fresh on the jiko
            and delivered hot across Nairobi.
          </p>
          <div className="mt-5 flex flex-wrap gap-2">
            <span className="flex items-center gap-1.5 rounded-full bg-secondary-foreground/10 px-3 py-1.5 text-xs font-bold">
              <Smartphone className="size-3.5 text-marigold" />
              M-Pesa
            </span>
            <span className="flex items-center gap-1.5 rounded-full bg-secondary-foreground/10 px-3 py-1.5 text-xs font-bold">
              <Wallet className="size-3.5 text-marigold" />
              Tando
            </span>
          </div>
        </div>

        {/* Explore */}
        <nav aria-label="Footer">
          <h3 className="text-sm font-bold uppercase tracking-[0.18em] text-marigold">Explore</h3>
          <ul className="mt-4 space-y-2.5 text-sm">
            {MENU_LINKS.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  className="text-secondary-foreground/75 transition-colors hover:text-secondary-foreground"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        {/* Contact */}
        <div>
          <h3 className="text-sm font-bold uppercase tracking-[0.18em] text-marigold">Talk to us</h3>
          <ul className="mt-4 space-y-2.5 text-sm text-secondary-foreground/75">
            <li className="flex items-start gap-2.5">
              <MapPin className="mt-0.5 size-4 shrink-0" />
              Kimathi Street, Nairobi, Kenya
            </li>
            <li className="flex items-center gap-2.5">
              <Phone className="size-4 shrink-0" />
              <span className="flex flex-col">
                <a href="tel:+254742534601" className="transition-colors hover:text-secondary-foreground">
                  0742 534 601
                </a>
                <a href="tel:+254746751723" className="transition-colors hover:text-secondary-foreground">
                  0746 751 723
                </a>
              </span>
            </li>
            <li className="flex items-center gap-2.5">
              <Mail className="size-4 shrink-0" />
              <a
                href="mailto:joywainaina3@gmail.com"
                className="break-all transition-colors hover:text-secondary-foreground"
              >
                joywainaina3@gmail.com
              </a>
            </li>
          </ul>
        </div>

        {/* Hours */}
        <div>
          <h3 className="text-sm font-bold uppercase tracking-[0.18em] text-marigold">Hours</h3>
          <ul className="mt-4 space-y-2.5 text-sm text-secondary-foreground/75">
            <li className="flex items-start gap-2.5">
              <Clock3 className="mt-0.5 size-4 shrink-0" />
              <span>
                Breakfast · 5:00 – 11:00 AM
                <br />
                Lunch · 11:00 AM – 4:00 PM
                <br />
                Dinner · 4:00 PM – midnight
              </span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-secondary-foreground/15">
        <div className="container flex flex-col items-center justify-between gap-3 py-5 text-xs text-secondary-foreground/60 sm:flex-row">
          <p>© {new Date().getFullYear()} MLO Foods · Nairobi, Kenya. Twakupenda!</p>
          <a
            href="https://shakespeare.diy"
            target="_blank"
            rel="noopener noreferrer"
            className="font-semibold transition-colors hover:text-secondary-foreground"
          >
            Vibed with Shakespeare
          </a>
        </div>
      </div>
    </footer>
  );
}
